import { Component, OnInit } from "@angular/core";
import { MonitoringEventLogViewModel } from "./monitoring-event-log.view-model";
import { MonitoringAlertsViewModel } from "../alerts/monitoring-alerts.view-model";
import { IMonitoringErrorsRepository } from "../../../domain/monitoring/i-monitoring-errors-repository";
import { UserService } from "../../../domain/user-service";
import { ChannelRepository } from "../../../domain/channel-repository";

@Component({
  selector: "evrideo-event-log",
  templateUrl: "./monitoring-event-log.component.html",
  styleUrls: ["./monitoring-event-log.component.scss"],
})
export class MonitoringEventLogComponent implements OnInit {
  vm: MonitoringEventLogViewModel;
  constructor(
    private _monitoringErrorsRepository: IMonitoringErrorsRepository,
    private _userService: UserService,
    private _channelRepository: ChannelRepository,
  ) {}

  async ngOnInit() {
    if (!MonitoringEventLogViewModel.LastState) {
      MonitoringEventLogViewModel.LastState = new MonitoringEventLogViewModel(
        this._monitoringErrorsRepository,
        this._userService,
        this._channelRepository,
      );
    }
    this.vm = MonitoringEventLogViewModel.LastState;

    await this.vm.onInit();
  }
}
